import {clearSession, writeNewToken} from "../service/authService/AuthService";
import {removeUserRefreshToken, removeUserToken} from "../service/localStorage/LocalStorageService";

export const actionTypes = {
    LOGIN: 'LOGIN',
    LOGOUT: 'LOGOUT',
    CHANGE_FUND: 'CHANGE_FUND',
}

export const initialState = {
    token: null,
    loading: true,
    role: [],
    fundID: -1,
    title: ""
}

export function reducer(state, action) {

    switch (action.type) {
        case actionTypes.LOGIN: {
            writeNewToken(action.token)
            return {
                ...state,
                token: action.token,
                loading: false,
                loginState: true,
                role: action.role,
                fundID: action.fundID,
                title: action.title,
                total_owner: action.total_owner
            }
        }
        case actionTypes.CHANGE_FUND:
            return {
                ...state,
                fundID: action.fundID,
                title: action.title
            }
        case actionTypes.LOGOUT: {
            clearSession()
            removeUserToken()
            removeUserRefreshToken()
            return {
                ...state,
                token: null,
                loading: false,
                loginState: false,
                role: [],
                fundID: -1,
                title: "",
                total_owner: false
            }
        }
        default: {
            clearSession()
            removeUserToken()
            removeUserRefreshToken()
            return {
                ...state,
                token: null,
                loading: false,
                loginState: false,
                role: [],
                fundID: -1,
                title: "",
                total_owner: false
            }
        }
    }
}

export function setLoginStateDispatch(actionType, token = "", role = null, fundID = -1, title = "صندوق های مردم نهاد", total_owner = false) {
    return {
        type: actionType,
        token: token,
        role: role,
        fundID: fundID,
        title: title,
        total_owner: total_owner
    }
}


export const AdminRoles = {
    "SUPER_ADMIN": {
        role: "SUPER_ADMIN",
        name: "مدیر کل"
    }, "READ_POSTS_LIST": {
        role: "READ_POSTS_LIST",
        name: ""
    }, "READ_POST_CATEGORY_TREE": {
        role: "READ_POST_CATEGORY_TREE",
        name: ""
    }, "READ_POST_TAGS_LIST": {
        role: "READ_POST_TAGS_LIST",
        name: ""
    }, "READ_FILES_LIST": {
        role: "READ_FILES_LIST",
        name: ""
    }, "READ_POST_WRITERS_LIST": {
        role: "READ_POST_WRITERS_LIST",
        name: ""
    }, "READ_POST_WRITER_INFORMATION": {
        role: "READ_POST_WRITER_INFORMATION",
        name: ""
    }, "READ_ADMINS_LIST": {
        role: "READ_ADMINS_LIST",
        name: ""
    }, "READ_ADMIN_INFORMATION": {
        role: "READ_ADMIN_INFORMATION",
        name: ""
    }, "READ_ADMIN_PERMISSIONS_LIST": {
        role: "READ_ADMIN_PERMISSIONS_LIST",
        name: ""
    }, "READ_TOUR_LEADERS_LIST": {
        role: "READ_TOUR_LEADERS_LIST",
        name: ""
    }, "READ_TOUR_LEADER_INFORMATION": {
        role: "READ_TOUR_LEADERS_LIST",
        name: ""
    },
}
